import React from "react";
import { Link } from "react-router-dom";

export function AccessDenied() {
  return (
    <main className="d-flex flex-column align-items-center justify-content-center min-vh-100 p-6 text-center">
      <div className="card card-custom p-10" style={{ maxWidth: 520 }}>
        <h1 className="font-size-h2 mb-4">Acceso no habilitado</h1>
        <p className="text-muted mb-8">
          Tu cuenta no tiene permisos para ingresar a este panel.
        </p>
        <Link to="/logout" className="btn btn-primary align-self-center">
          Cerrar sesión
        </Link>
      </div>
    </main>
  );
}
